import type { SendResult } from '@/api/types';
import type { SendOutcome, SentMessageLink } from './pendingSend';

/** The notice for a send that went and needs no remark, when it has an action. */
export const SENT_LABEL = 'Message sent';

/**
 * What the strip says after a send, or `undefined` when there is nothing to
 * say at all.
 *
 * A caveat is said as before: the server's `warning` (for a copy to Sent that
 * failed, its own sentence about the retry, #84), or refused recipients. A
 * clean send is quiet unless the server told us where the copy in Sent is, and
 * then it is a plain "Message sent" whose only purpose is "View message", the
 * way Gmail does it. A mailbox whose server files sent mail itself
 * (`sentFiledByServer`) has no copy to point at and no warning, so it stays
 * quiet: that is how the mailbox works, not a fault.
 */
export function sendOutcome(accountId: string, result: SendResult): SendOutcome | undefined {
  const view: SentMessageLink | undefined =
    result.sentMessageId !== undefined &&
    result.sentMessageId !== '' &&
    result.savedToFolderId !== undefined &&
    result.savedToFolderId !== ''
      ? { accountId, folderId: result.savedToFolderId, messageId: result.sentMessageId }
      : undefined;
  const caveat =
    result.rejected.length > 0 || result.warning
      ? (result.warning ?? 'Sent, but some recipients were refused.')
      : undefined;
  if (caveat !== undefined) return { label: caveat, ...(view !== undefined ? { view } : {}) };
  if (view !== undefined) return { label: SENT_LABEL, view, routine: true };
  return undefined;
}
